module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "processedArchives"
    }
  }, [_c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('arquivosProcessados.titulos.titulo'),
      "subTitle": _vm.$t('arquivosProcessados.titulos.subtitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('arquivosProcessados.titulos.filtro')
    }
  }, [_c('form-search', {
    attrs: {
      "slot": "filters",
      "fn": _vm.validate,
      "isDisabled": _vm.disableSearchButton,
      "showLoadingFullPage": false,
      "hasExportFile": false
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row-filter-small"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 365
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('archivesPeriodLimited', 'required')),
      expression: "errors.firstByRule('archivesPeriodLimited', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('arquivosProcessados.erros.periodoLimitado'))
    }
  })], 1), _c('div', {
    staticClass: "row"
  })])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegrid),
      expression: "showTreegrid"
    }]
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "processedFilesGrid",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "arquivosProcessados",
      "cfgObj": _vm.treeGridCfg
    }
  })], 1)], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6f5ddfa2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f5ddfa2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/integration/processedFiles/processedFiles.pug
// module id = 1431
// module chunks = 0